import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c15325ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clearfix" }
const _hoisted_2 = { style: {"float":"right"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 查看全部问答 ")
const _hoisted_4 = { class: "clearfix questionwrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle question" }, "问", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "info" }
const _hoisted_8 = {
  key: 0,
  class: "clearfix answerwrap"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "circle answer" }, "答", -1))
const _hoisted_10 = { class: "info" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_Askcollapse = _resolveComponent("Askcollapse")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["content", _ctx.theme])
  }, [
    _createElementVNode("section", null, [
      _createElementVNode("h3", null, [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.titleInfo.Inst), 513), [
            [_vShow, _ctx.titleInfo.Inst]
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.titleInfo.Name), 1),
          _withDirectives(_createElementVNode("span", {
            class: _normalizeClass(_ctx.titleInfo.increase > 0 ? 'red' : _ctx.titleInfo.increase < 0 ? 'green' : '')
          }, _toDisplayString(_ctx.getNumber(_ctx.titleInfo.LastPrice)), 3), [
            [_vShow, _ctx.titleInfo.type !== 'all']
          ]),
          _withDirectives(_createElementVNode("span", {
            class: _normalizeClass(_ctx.titleInfo.increase > 0 ? 'red' : _ctx.titleInfo.increase < 0 ? 'green' : '')
          }, _toDisplayString(_ctx.titleInfo.increase > 0 ? '+' : '') + _toDisplayString(_ctx.getPencent(_ctx.titleInfo.increase)), 3), [
            [_vShow, _ctx.titleInfo.type !== 'all']
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_a_button, {
              type: "link",
              block: "",
              size: "small",
              onClick: _ctx.gotoDetail
            }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createVNode(_component_RightOutlined, { style: {"margin":"0"} })
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _createVNode(_component_a_spin, {
        tip: "加载中...",
        spinning: _ctx.loading,
        wrapperClassName: _ctx.PageID !== 1 && _ctx.loading ? 'bottomloading': ''
      }, {
        default: _withCtx(() => [
          (_ctx.cardList.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["cardwrap", {'datawrap': !_ctx.allloaded }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_a_card, {
                    key: item.Inst + '' + i,
                    bordered: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _createElementVNode("p", {
                            innerHTML: item.QContent
                          }, null, 8, _hoisted_6),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(item.QAuthor), 1),
                            _createElementVNode("span", null, _toDisplayString(item.QTime), 1)
                          ])
                        ]),
                        (item.AContent)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _hoisted_9,
                              _createElementVNode("p", null, [
                                _createVNode(_component_Askcollapse, {
                                  content: item.AContent,
                                  sign: 'ask',
                                  lineclamp: 5
                                }, null, 8, ["content"])
                              ]),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", null, _toDisplayString(item.ATime), 1),
                                _createElementVNode("span", null, "来源：" + _toDisplayString(item.Exch === 'sz' ? '深交所互动易' : item.Exch === 'sh' ? '上交所互动易' : '全景网'), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_Nodata, {
                  class: "cardwrap",
                  mode: "vertical",
                  customdesc: '暂无问答'
                })
              ]))
        ]),
        _: 1
      }, 8, ["spinning", "wrapperClassName"])
    ]),
    _createVNode(_component_a_modal, {
      class: "tipsmodal",
      wrapClassName: "tipsmodalwrap",
      zIndex: 0,
      visible: _ctx.modalVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.modalVisible) = $event)),
      "ok-text": "",
      "cancel-text": "",
      footer: null,
      content: null,
      mask: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            src: require('@/assets/images/tips.svg'),
            alt: ""
          }, null, 8, _hoisted_12),
          _createElementVNode("span", null, "已为您发现" + _toDisplayString(_ctx.updateIndex) + "条新问答", 1),
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.freshdata && _ctx.freshdata(...args)))
          }, "点此更新")
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 2))
}